import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { RouteData } from '@sondermind/utilities/services';

@Component({
  selector: 'app-client-notes-container',
  templateUrl: './client-notes-container.component.html',
  styleUrls: ['./client-notes-container.component.scss'],
  standalone: false
})

export class ClientNotesContainerComponent implements OnInit {
  constructor(
    private router: Router,
    private routeData: RouteData,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.checkRouteRedirect();
  }
  checkRouteRedirect() {
    const previousUrl = this.routeData.getPreviousUrl();
    const previousUrlWasMatches = previousUrl && previousUrl.includes('matches');
    this.router.navigate(['smart_notes'], { relativeTo: this.activatedRoute.parent.parent, queryParams: { matchList: previousUrlWasMatches } });
  }
}
